import PropTypes from "prop-types";
import React from "react";
import {locations} from "../../Utilities/Location";
import {PageNavigation, PageTitle} from "../Landmarks";
import {ContentSmall} from "../Layout";

const NotAuthorized = ({redirect}) => {

    const handleLogoutClick = () => {
        redirect(locations.SIGN_OUT.path);
    };

    return (
        <ContentSmall>
            <PageTitle h1={`Not Authorized`} hasBorder/>
            <PageNavigation handlePrimaryClick={handleLogoutClick} labelPrimary={"Logout"} />
        </ContentSmall>
    );
};

NotAuthorized.propTypes = {
    redirect: PropTypes.func.isRequired,
};


export default NotAuthorized;
